import { Component, input } from '@angular/core';

import { InfoboxComponent } from '@core/components-infobox-legacy';
import { TranslatePipe } from '@core/i18n-legacy';

import { ChurnFlowStepCounterComponent } from '../churn-flow-step-counter/churn-flow-step-counter.component';
import { ChurnFlowTellentLogoComponent } from '../churn-flow-tellent-logo/churn-flow-tellent-logo.component';

type RightPanelBackgroundVariant = 'plain' | 'shaped';

@Component({
  selector: 'tlc-churn-flow-step-template',
  templateUrl: './churn-flow-step-template.component.html',
  styleUrls: ['./churn-flow-step-template.component.less'],
  imports: [
    ChurnFlowTellentLogoComponent,
    ChurnFlowStepCounterComponent,
    TranslatePipe,
    InfoboxComponent,
  ],
})
export class ChurnFlowStepTemplateComponent {
  public readonly numberOfSteps = 4;

  public rightPanelBackgroundVariant = input<RightPanelBackgroundVariant>('shaped');
  public currentStep = input<number>();
  public reasonInfoboxMessage = input<string>();
}
